"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureRegionalLatencies = void 0;
const REGIONS = [
    'af-south-1',
    'ap-east-1',
    'ap-northeast-1',
    'ap-northeast-2',
    'ap-northeast-3',
    'ap-south-1',
    'ap-southeast-1',
    'ap-southeast-2',
    'ca-central-1',
    'eu-central-1',
    'eu-north-1',
    'eu-south-1',
    'eu-west-1',
    'eu-west-2',
    'eu-west-3',
    'me-south-1',
    'sa-east-1',
    'us-east-1',
    'us-east-2',
    'us-west-1',
    'us-west-2'
];
const measureRegionalLatency = (region) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        //Pre-fetch to make sure the DNS record is cached
        yield fetch(`https://ec2.${region}.amazonaws.com/ping`);
        //The actual measurement we'll use
        const startTime = performance.now();
        yield fetch(`https://ec2.${region}.amazonaws.com/ping`);
        const elapsedTime = performance.now() - startTime;
        return {
            measurement: Math.round(elapsedTime),
            region
        };
    }
    catch (error) {
        return {
            measurement: Number.MAX_SAFE_INTEGER,
            region
        };
    }
});
exports.measureRegionalLatencies = () => __awaiter(void 0, void 0, void 0, function* () {
    const startTime = performance.now();
    const measurements = REGIONS.map((region) => measureRegionalLatency(region));
    const latencies = yield Promise.all(measurements);
    const elapsedTime = performance.now() - startTime;
    latencies.sort((a, b) => {
        if (a.measurement > b.measurement) {
            return 1;
        }
        if (b.measurement > a.measurement) {
            return -1;
        }
        return 0;
    });
    // eslint-disable-next-line no-console
    console.log(latencies, elapsedTime);
    return latencies;
});
//# sourceMappingURL=RegionalLatencyMeasurement.js.map